import { TLink, useRouting } from '@/core/hooks/useRouting'
import NavMenuItem from '../NavMenuItem/NavMenuItem'
import {
    NavBarItems,
    SeparatorLabel,
    SidebarSeparator,
} from './sidebarItems.styles'
import { useTheme } from '@mui/material'
import { TTheme } from '@/core/theme'

type SidebarItemsProps = {
    close?: () => void
}

const SidebarItems = ({ close }: SidebarItemsProps) => {
    const theme = useTheme<TTheme>()
    const { sideNavbarLinks, isActiveLink } = useRouting()

    return sideNavbarLinks.map((link: TLink) => {
        if (link.isHidden) return null

        if (link.kind === 'separator') {
            return (
                <SidebarSeparator
                    key={link.id}
                    data-testid={`sidebar-separator-${link.id}`}
                >
                    <SeparatorLabel
                        color={theme.colors.greys[0]}
                        variant="s-light"
                        textTransformRule="uppercase"
                    >
                        {link.text}
                    </SeparatorLabel>
                </SidebarSeparator>
            )
        }

        return (
            <NavBarItems key={link.id}>
                <NavMenuItem
                    boldIcon={link.boldIcon}
                    ExtraIcon={link.extraIcon}
                    Icon={link.icon}
                    key={link.route?.displayName}
                    text={link.route?.displayName || link.text || ''}
                    active={(link.route && isActiveLink(link.route)) || false}
                    onClick={() => {
                        link.onClick && link.onClick()
                        close && close()
                    }}
                />
            </NavBarItems>
        )
    })
}

export default SidebarItems
